import { useIsPrint } from './isPrint'
import { sleep } from '~/utils'

export const useExporter = createGlobalState(() => {
  const isPdfModalOpen = ref(false)
  const isCommentEditorOpen = ref(false)

  const reportComment = ref('')

  const isPrint = useIsPrint()

  const resetComment = () => {
    reportComment.value = ''
  }

  const cancelPdf = () => {
    isPdfModalOpen.value = false
    isCommentEditorOpen.value = false
    resetComment()
  }

  const addComment = () => {
    isPdfModalOpen.value = false
    isCommentEditorOpen.value = true
  }

  const printPDF = () => {
    window.print()
  }

  const createPdf = async () => {
    isPdfModalOpen.value = false
    isCommentEditorOpen.value = false
    isPrint.value = true
    await sleep(500)
    printPDF()
    isPrint.value = false
  }

  const downloadCSV = () => {
    alert('TODO: download CSV')
  }

  return {
    isPdfModalOpen,
    isCommentEditorOpen,
    reportComment,
    downloadCSV,
    cancelPdf,
    addComment,
    createPdf,
    resetComment,
  }
})
